import { registerEnumSet, type EnumDescriptor } from '@if/mui'
import { ELoanStatus, getELoanStatusList } from '@src/types/constants'
import { CircleCheck, CircleDashed, CircleDot, CirclePause, CircleX } from 'lucide-react'

export const ELoanStatusSet = Object.fromEntries(
  getELoanStatusList().map((status) => [ELoanStatus[status], String(status)]),
) as { [K in keyof typeof ELoanStatus]: `${(typeof ELoanStatus)[K]}` }

export type ELoanStatusValue = (typeof ELoanStatusSet)[keyof typeof ELoanStatusSet]

export const toLoanStatusValue = (status: ELoanStatus): ELoanStatusValue => String(status) as ELoanStatusValue

const WAITING = { color: 'info', icon: CircleDashed } satisfies Omit<EnumDescriptor, 'labelKey'>
const LIVING = { color: 'success', icon: CircleDot } satisfies Omit<EnumDescriptor, 'labelKey'>
const ON_HOLD = { color: 'warning', icon: CirclePause } satisfies Omit<EnumDescriptor, 'labelKey'>
const ENDED = { color: 'secondary', icon: CircleCheck } satisfies Omit<EnumDescriptor, 'labelKey'>
const NEVER_LIVED = { color: 'secondary', icon: CircleX } satisfies Omit<EnumDescriptor, 'labelKey'>

registerEnumSet(ELoanStatusSet, {
  1: { ...WAITING, labelKey: 'loan.loanStatuses.1' },
  2: { ...LIVING, labelKey: 'loan.loanStatuses.2' },
  3: { ...ON_HOLD, labelKey: 'loan.loanStatuses.3' },
  4: { ...ENDED, labelKey: 'loan.loanStatuses.4' },
  5: { ...NEVER_LIVED, labelKey: 'loan.loanStatuses.5' },
})
